import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {useNavigate} from "react-router-dom";
import {deleteIntegration} from "../../../../modules/assistant/page/integrations/slice/integrationsSlice";
import {DeleteIntegrationRequest} from "../../../../../api/generated";

interface ConfirmationModalProps {
    deleteRequest: DeleteIntegrationRequest
    handleClose: (value?: any) => any
    onClickRedirectPath?: string
}

export const DeleteIntegrationConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                         deleteRequest,
                                                                                         handleClose,
                                                                                         onClickRedirectPath
                                                                                     }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const handleDelete = () => {
        dispatch(deleteIntegration(deleteRequest))
        handleClose()
        if (onClickRedirectPath) {
            navigate(onClickRedirectPath)
        }
    }

    return <ConfirmationModal
        title={"Delete the integration"}
        subtitle={"Are you sure you want to delete this integration? You won't be able to undo this action."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
    />
}
